import 'reflect-metadata';
import {jsonArrayMember, jsonObject} from 'typedjson';

import {VpnSettings} from '@/model/network/settings/VpnSettings';

export class OpenVpnSettingsRemote {

  public static Serialize(remote: OpenVpnSettingsRemote): string {
    if (remote.Protocol) {
      return `${remote.Host}:${remote.Port}:${remote.Protocol}`;
    } else {
      return `${remote.Host}:${remote.Port}`;
    }
  }

  public static Deserialize(data: string): OpenVpnSettingsRemote {
    const parts = data.split(':');

    if (parts.length < 2) {
      throw Error(`bad remote format, expecting three parts (: separated), got ${parts.length} (${data})`);
    }

    return new OpenVpnSettingsRemote({
      Host: parts[0],
      Port: +parts[1],
      Protocol: parts.length > 2 ? parts[2] : undefined,
    });
  }

  public Host?: string;
  public Port?: number;
  public Protocol?: string;

  constructor(args: Partial<OpenVpnSettingsRemote>) {
    Object.assign(this, args);
  }
}

@jsonObject({
  onDeserialized: 'DeserializeRemotes',
  beforeSerialization: 'SerializeRemotes',
})
export class OpenVpnSettings extends VpnSettings {

  public Remotes?: OpenVpnSettingsRemote[];

  constructor(vpnSettings?: Partial<OpenVpnSettings>) {
    super(vpnSettings);

    this.Remotes = vpnSettings?.Remotes?.map((r) => new OpenVpnSettingsRemote(r));
  }

  /**
   * This method is called after deserialization by TypedJSON from the API to generate a proper Remotes field
   * corresponding to the Data field
   */
  public DeserializeRemotes() {
    this.Remotes = this.Data?.get('remote')?.split(', ').map((r) => OpenVpnSettingsRemote.Deserialize(r)) ?? undefined;
  }

  /**
   * This method is called before deserialization by TypedJSON for the API to generate a proper Data field
   * corresponding to the Remotes field
   */
  public SerializeRemotes() {
    if (this.Remotes) {
      this.Data?.set('remote', this.Remotes.map((r) => OpenVpnSettingsRemote.Serialize(r)).join(', '));
    }
  }

  public get Name(): string {
    return 'OpenVPN';
  }

  public get ConnectionType(): string | undefined {
    return this.Data?.get('connection-type')?.toUpperCase() ?? undefined;
  }

  public set ConnectionType(data: string | undefined) {
    if (data) {
      this.Data.set('connection-type', data);
    } else {
      this.Data.delete('connection-type');
    }
  }

}
